module.exports = __webpack_public_path__ + "media/images/graph-image-57ff3171f2ad03513ae36de69adae16d.svg";